var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckChevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6666 44.4762V46.0095C62.6645 49.6036 61.5008 53.1006 59.3488 55.9792C57.1969 58.8578 54.1721 60.9636 50.7255 61.9827C47.279 63.0017 43.5954 62.8794 40.224 61.6338C36.8527 60.3883 33.9743 58.0863 32.0182 55.0713C30.062 52.0562 29.1329 48.4896 29.3694 44.9034C29.6059 41.3171 30.9953 37.9034 33.3304 35.1713C35.6655 32.4392 38.8212 30.5352 42.3269 29.7431C45.8326 28.951 49.5004 29.3134 52.7833 30.7762M62.6666 32.6666L45.9999 49.35L40.9999 44.35",
    stroke: "#039855",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckChevron);
export default __webpack_public_path__ + "static/media/check-chevron.7f62f557faf2e87fae425efb34a8cc1f.svg";
export { ForwardRef as ReactComponent };